// react-router-dom components
import { NavLink } from 'react-router-dom'

// @mui material components
import Card from '@mui/material/Card'

// Material Dashboard 2 React components
import MDBox from '../../../components/MDComponents/MDBox'
import MDTypography from '../../../components/MDComponents/MDTypography'
import MDInput from '../../../components/MDComponents/MDInput'

import { GoogleLogin } from '@react-oauth/google'

// Authentication layout components
import CoverLayout from '../../../layouts/authentication/components/CoverLayout'

import useRegister from './useRegister'
import Button from '../../../components/Button'
import { useMaterialUIController } from '../../../context'

import pages from 'constants/pages'
import { settings } from 'settings'

const Register = () => {
  const {
    handleChange,
    inputs,
    errors,
    handleGeneratePassword,
    handleSubmit,
    handleGoogleLoginError,
    handleCheckbox,
    handleGoogleLoginSuccess,
    isLoading,
  } = useRegister()
  const [controller] = useMaterialUIController()
  const { theme } = controller
  return (
    <CoverLayout>
      <Card className="!bg-secondary-background">
        <div className="bg-btn-primary rounded-lg mx-2 p-3  text-center">
          <div className="text-over-primary font-medium text-2xl mt-1">
            Fă-ți acum un cont!
          </div>
          <div className="text-over-primary text-sm mt-1">
            Începe să înveti pentru {settings.exam_type} într-un mod inteligent
          </div>
        </div>
        <MDBox pt={4} pb={3} px={3}>
          <form>
            <MDBox component="form" role="form" method="POST">
              <MDBox mb={1}>
                <MDInput
                  label="Nume"
                  type="name"
                  variant="standard"
                  fullWidth
                  value={inputs.name}
                  name="name"
                  id="name-input"
                  onChange={handleChange}
                  error={errors.nameError}
                  inputProps={{
                    autoComplete: 'name',
                    form: {
                      autoComplete: 'off',
                    },
                    style: { fontSize: 16 },
                  }}
                />
                {errors.nameError && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                    id="name-error"
                  >
                    Numele nu este valid
                  </MDTypography>
                )}
              </MDBox>
              <MDBox mb={1}>
                <MDInput
                  type="email"
                  label="Email"
                  variant="standard"
                  fullWidth
                  value={inputs.email}
                  name="email"
                  id="email-input"
                  onChange={handleChange}
                  error={errors.emailError}
                  inputProps={{
                    autoComplete: 'email',
                    form: {
                      autoComplete: 'off',
                    },
                    style: { fontSize: 16 },
                  }}
                />
                {errors.emailError && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                    id="email-error"
                  >
                    Adresa de email nu este validă
                  </MDTypography>
                )}
                {errors.existError && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                    id="already-used-email-error"
                  >
                    Există deja un cont cu această adresă de email
                  </MDTypography>
                )}
              </MDBox>
              <MDBox mb={1}>
                <MDInput
                  showPassword
                  suggestPassword
                  type="password"
                  label="Parolă"
                  variant="standard"
                  fullWidth
                  id="password-input"
                  name="password"
                  handleGeneratePassword={handleGeneratePassword}
                  value={inputs.password}
                  onChange={handleChange}
                  error={errors.passwordError}
                  inputProps={{ style: { fontSize: 16 } }}
                />
                {errors.passwordError && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                    id="small-password-error"
                  >
                    Parola trebuie să aibă minim 8 caractere
                  </MDTypography>
                )}
              </MDBox>
              <MDBox mb={1}>
                <MDInput
                  showPassword
                  type="password"
                  label="Repetă parola"
                  id="confirm-password-input"
                  variant="standard"
                  fullWidth
                  handleGeneratePassword={handleGeneratePassword}
                  name="confirm"
                  value={inputs.confirm}
                  onChange={handleChange}
                  error={errors.confirmError}
                  inputProps={{ style: { fontSize: 16 } }}
                />
                {errors.confirmError && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                    id="different-password-error"
                  >
                    Parolele trebuie sa coincidă
                  </MDTypography>
                )}
              </MDBox>
              <MDBox
                display="flex"
                alignItems="center"
                pt={1}
                lineHeight="1.625"
              >
                <input
                  type="checkbox"
                  name="agree"
                  id="agree-input"
                  onChange={handleCheckbox}
                />
                <label
                  className="text-over-secondary-background text-sm ml-3 cursor-pointer"
                  htmlFor="agree-input"
                >
                  Sunt de acord cu&nbsp;
                  <NavLink
                    to={pages.other.termsAndConditions}
                    className="text-primary font-medium"
                  >
                    Termenii si Condițiile&nbsp;
                  </NavLink>
                  și cu&nbsp;
                  <NavLink
                    className="text-primary font-medium"
                    to={pages.other.privacyPolicy}
                  >
                    Politica de Confidențialitate
                  </NavLink>
                </label>
              </MDBox>
              {errors.agreeError && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                  id="checkbox-error"
                >
                  Trebuie să fii de acord cu cele de mai sus
                </MDTypography>
              )}
              {errors.error && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                >
                  {errors.errorText}
                </MDTypography>
              )}
              <MDBox
                display="flex"
                alignItems="center"
                justifyContent="center"
                pt={1}
              >
                <GoogleLogin
                  theme={theme === 'dark' ? 'filled_black' : 'filled_white'}
                  onSuccess={handleGoogleLoginSuccess}
                  onError={handleGoogleLoginError}
                />
              </MDBox>
              <MDBox mt={4} mb={1}>
                <Button
                  onClick={handleSubmit}
                  className="w-full h-10 bg-btn-primary text-over-primary"
                  isLoading={isLoading}
                  type="submit"
                  id="signup-button"
                >
                  Înregistrează-te
                </Button>
              </MDBox>
              <MDBox mt={3} mb={1} textAlign="center">
                <div className="text-over-secondary-background pb-1 text-sm">
                  Ai deja un cont?{' '}
                  <NavLink
                    to={pages.auth.login}
                    className="text-primary font-medium"
                  >
                    Autentifică-te!
                  </NavLink>
                </div>
              </MDBox>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </CoverLayout>
  )
}

export default Register
